import React, { FC, ReactElement, useState } from 'react';
import { Extra } from './objects/Extra';
import { Button, FormControl, Grid, IconButton, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import { Edit, Remove } from '@mui/icons-material';
import { addExtraListDefinition, patchExtraListDefinition } from './services/extraServices';
import { useSelector } from 'react-redux';
import { AppState } from '../../reducers';

interface CardProps {
    extra: Extra,
    editExtra: number | null,
    setEditExtra: (value: number | null) => void,
    index: number,
    removeFromList: (extra: Extra) => void,
    setExtraList: (value: Extra[]) => void,
    cancelExtra: () => void,
    extraList: Extra[]
}
const ManualAccommodationExtraCard: FC<CardProps> = ({ extra, editExtra, setEditExtra, removeFromList, index, setExtraList, extraList, cancelExtra }): ReactElement => {
    const client_id = useSelector((state:AppState) => state.header.client_id);
    const [labelError, setLabelError] = useState(false);
    const [refError, setRefError] = useState(false);
    const [extraLabel, setExtraLabel] = useState(extra.label);
    const [extraRef, setExtraRef] = useState(extra.reference);
    const checkBeforeValidate = () => {
        if (extraLabel === '') {
            setLabelError(true);
        }
        if (extraRef === '') {
            setRefError(true);
        }
        if (extraLabel !== '' && extraRef !== '') {
            onChangeField();
            setEditExtra(null);
        }
    };
    const onChangeField = () => {
        if (extra.id === undefined) {
            addExtraListDefinition(client_id, { label: extraLabel, reference: extraRef }).then((response) => {
                setExtraList((state) => {
                    let tmp_extra = [...state];
                    tmp_extra[index].label = extraLabel;
                    tmp_extra[index].reference = extraRef;
                    return tmp_extra;
                });
            });
        } else {
            patchExtraListDefinition(client_id, { label: extraLabel, reference: extraRef, id: extra.id }).then((response) => {
                setExtraList((state) => {
                    let tmp_extra = [...state];
                    tmp_extra[index].label = extraLabel;
                    tmp_extra[index].reference = extraRef;
                    return tmp_extra;
                });
            });
        }
    };
    const onCancel = () => {
        if (extraList[index].label === '' || extraList[index].reference === '') {
            cancelExtra();
        }
        setEditExtra(null);
        setExtraLabel('');
        setExtraRef('');
    };
    return (
        <Grid item key={extra.reference} sx={{ border: '1px solid #707070', padding: 1, margin: 1, borderRadius: '16px' }}>
            {
                editExtra !== index &&
                <Stack direction={'column'} spacing={ 2 } sx={{ m: '20px !important' }}>
                    <Stack direction={'row'} spacing={ 2 } alignItems={'center'}>
                        <Typography variant={'subtitle1'}>{extra.label}</Typography>
                        <IconButton size='small' onClick={() => setEditExtra(index)}><Edit /></IconButton>
                    </Stack>
                    <Stack direction={'row'} justifyContent={'space-between'} spacing={ 8 }>
                        <Typography variant={'subtitle2'}>Ref: {extra.reference}</Typography>
                        <Button size='small' variant={'contained'} onClick={() => removeFromList(extra)}><Remove /></Button>
                    </Stack>
                </Stack>
            }
            {
                editExtra === index &&
                <Stack direction={'column'} spacing={ 2 } sx={{ m: '20px !important' }}>
                    <FormControl fullWidth variant={'outlined'}>
                        {<InputLabel htmlFor={'extra-label'}>{'Nom'}</InputLabel>}
                        <OutlinedInput
                            id={'extra-label'}
                            type={'text'}
                            onChange={(e) => setExtraLabel(e.target.value)}
                            label={'Nom'}
                            value={extraLabel}
                            autoComplete={'off'}
                            error={labelError}
                        />
                    </FormControl>
                    <FormControl fullWidth variant={'outlined'}>
                        {<InputLabel htmlFor={'extra-ref'}>{'Ref'}</InputLabel>}
                        <OutlinedInput
                            id={'extra-ref'}
                            type={'text'}
                            onChange={(e) => setExtraRef(e.target.value)}
                            label={'Ref'}
                            value={extraRef}
                            autoComplete={'off'}
                            error={refError}
                        />
                    </FormControl>
                    <Stack spacing={ 2 } direction={'row'}>
                        <Button size='small' variant={'contained'} fullWidth onClick={onCancel}>Annuler</Button>
                        <Button size='small' variant={'contained'} fullWidth onClick={checkBeforeValidate}>Valider</Button>
                    </Stack>
                </Stack>
            }
        </Grid>
    );
};
export default ManualAccommodationExtraCard;
